import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const userBoardRoute: InvariantJiraRoute = {
	name: 'rapidboard-user-board',
	path: '/jira/people/:accountId/boards/:boardId',
};
